/**
 * HR -> Employee -> CRM Partner (Go-live 1 November checklist).
 *
 * Superuser-only endpoints in backend/employees/hr_crm_partner_views.py:
 *  - get:    the employee's linked partner, or the data summary a new one gets
 *  - create: make the partner from the employee record (409 + existing_profile
 *            when a partner with the same name exists)
 *  - link:   link the employee to that existing partner instead
 *
 * Errors are re-thrown untouched: screens read `response.status` (409) and
 * `response.data.existing_profile`, and show `response.data.error`.
 */
import axiosInstance from '../utils/axiosConfig';

const base = (employeeId) => `/api/admin/hms/employees/${employeeId}/crm-partner/`;

const employeeCrmPartnerService = {
  get: async (employeeId) => (await axiosInstance.get(base(employeeId))).data,
  create: async (employeeId) => (await axiosInstance.post(base(employeeId), {})).data,
  link: async (employeeId, profileId) => (
    await axiosInstance.post(`${base(employeeId)}link/`, { profile_id: profileId })
  ).data,
};

export default employeeCrmPartnerService;
